import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';
import { OrderLineItemsSummary } from './OrderLineItemsSummary.js';

const OrderLineItemsSummaryContainer = ({ order  })=>{
    const { getLabel , currency , locale , getFormattedLabel  } = useIntl();
    const labels = {
        summaryLabel: getLabel('cart.discount.summary'),
        subtotal: getLabel('cart.value.subTotal'),
        total: getLabel('cart.value.total'),
        totalDiscount: getLabel('cart.value.totalDiscount'),
        delivery: getLabel('cart.delivery'),
        freeDelivery: getLabel('cart.delivery.forFree'),
        paymentMethod: order.paymentMethod,
        donationTitle: getLabel('checkout.payment.donation.summary.title'),
        donationDisclaimer: order.donation ? getFormattedLabel('checkout.payment.donation.summary.description', {
            labelData: {
                total: formatPrice({
                    locale,
                    value: order.donation.totalWithDonation,
                    currency,
                    isCentAmount: true
                }),
                cartTotal: formatPrice({
                    locale,
                    value: order.totalPrice,
                    currency,
                    isCentAmount: true
                }),
                donationTotal: formatPrice({
                    locale,
                    value: order.donation.amount,
                    currency,
                    isCentAmount: true
                })
            }
        }) : ''
    };
    const prices = {
        subtotal: order.subtotalAmount,
        totalDiscount: order.discountedAmount,
        delivery: order.shippingMethodPrice,
        total: order.totalPrice,
        paymentMethodPrice: order.paymentMethodPrice,
        donationAmount: order.donation ? formatPrice({
            locale,
            value: order.donation.amount,
            currency,
            isCentAmount: true
        }) : undefined
    };
    return /*#__PURE__*/ React.createElement(OrderLineItemsSummary, {
        currency: currency,
        labels: labels,
        prices: prices
    });
};

export { OrderLineItemsSummaryContainer };
//# sourceMappingURL=OrderLineItemsSummaryContainer.js.map
